import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Paper,
} from "@mui/material";
import { IoCloseOutline } from "react-icons/io5";

const sizes = [
  {
    feet: "2 × 5 ft",
    cm: "60 × 150 cm",
    inches: "24 × 59 in",
    meters: "0.6 × 1.5 m",
  },
  {
    feet: "2'6 × 4'6 ft",
    cm: "80 × 140 cm",
    inches: "32 × 55 in",
    meters: "0.8 × 1.4 m",
  },
  {
    feet: "2'6 × 5 ft",
    cm: "80 × 150 cm",
    inches: "32 × 59 in",
    meters: "0.8 × 1.5 m",
  },
  {
    feet: "4 × 5'6 ft",
    cm: "120 × 170 cm",
    inches: "47 × 67 in",
    meters: "1.2 × 1.7 m",
  },
  {
    feet: "4 × 6 ft",
    cm: "120 × 180 cm",
    inches: "47 × 71 in",
    meters: "1.2 × 1.8 m",
  },
  {
    feet: "5 × 7'6 ft",
    cm: "160 × 230 cm",
    inches: "63 × 91 in",
    meters: "1.6 × 2.3 m",
  },
  {
    feet: "6'6 × 9'6 ft",
    cm: "200 × 290 cm",
    inches: "79 × 114 in",
    meters: "2.0 × 2.9 m",
  },
  {
    feet: "8 × 11 ft",
    cm: "240 × 340 cm",
    inches: "95 × 134 in",
    meters: "2.4 × 3.4 m",
  },
];

const SizeChart = ({ isOpen, onClose }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ flexGrow: 1, textAlign: "center", marginBottom: "16px" }}>
          Size Conversion Chart
        </div>
        <Button onClick={onClose} sx={{ fontSize: "24px", color: "#000" }}>
          <IoCloseOutline />
        </Button>
      </DialogTitle>

      <DialogContent>
        <TableContainer component={Paper}>
          <Table sx={{ border: "1px solid #ddd", color: "black" }}>
            <TableHead sx={{ background: "black", color: "#fff" }}>
              <TableRow>
                <TableCell
                  sx={{ borderRight: "1px solid #ddd", color: "#fff" }}
                >
                  ft
                </TableCell>
                <TableCell
                  sx={{ borderRight: "1px solid #ddd", color: "#fff" }}
                >
                  cm
                </TableCell>
                <TableCell
                  sx={{ borderRight: "1px solid #ddd", color: "#fff" }}
                >
                  inches
                </TableCell>
                <TableCell sx={{ color: "#fff" }}>meters</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sizes.map((size, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    {size.feet}
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    {size.cm}
                  </TableCell>
                  <TableCell sx={{ borderRight: "1px solid #ddd" }}>
                    {size.inches}
                  </TableCell>
                  <TableCell>{size.meters}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default SizeChart;
